//@vendors
const Immutable = require('immutable');
const get = require('lodash/object/get');
const { handleActions, combineActions } = require('redux-actions');
// @core
const { formatText } = require('core/i18n').i18n;
//@actions
const { simpleActions } = require('../../actions/contractPayrollLoan');
//@constants
const { SECOND_STEP, EURO_TEXT } = require('constants/index');
const {
    contractEasyLoan,
    payrollLoanJobs,
    payrollLoanLayoutKOxDTI,
    payrollLoanRecordStatus: { contractStatus: { NUEVA_OFERTA } }
} = require('../../loansConstants/index');
//@utilities
const { decimalsLength } = require('utilities/currencyHelper');

const setInitialState = () => Immutable.fromJS({
    steps: [
        { valid: false },
        { valid: true, hasSignaturePattern: true }
    ],
    installment: {
        amount: 0,
        currency: EURO_TEXT,
        decimalsLength: 0
    },
    newOffer: {
        seletedAmountOrTerm: false
    },
    offer: {
        selectedAmount: 0,
        selectedTerm: 0,
        changed: false,
        isFetching: false
    },
    proposition: {
        isFetching: false,
        success: false
    },
    agree: false,
    agreeError: false,
    timesTampCheckBox: null,
    arrangementFee: 0,
    arrangementMin: 0,
    arrangementPercentage: 0,
    callingApproveService: false,
    currency: EURO_TEXT, //@hardcoded
    currentDateReferenceStandard: '',
    displayNewOfferView: false,
    documents: null,
    endOfMonthReferenceStandard: '',
    error: false,
    errorContractInitialize: false,
    emptySelectedAccount: false,
    indCapson: '',
    initialized: false,
    isCollective: false,
    isFetching: false,
    isFetchingDocuments: !__CONTACT_CENTER__, // We don´t fetch documents in CC - the PDF viewer is hidden
    isFetchingFormalize: false,
    isFetchingInstallment: false,
    isFetchingOffer: false,
    isFetchingOfferDTI: false,
    isFetchingTotalImport: false,
    isFetchingMinTerm: false,
    isFetchingZip: false,
    isInactiveAccount: false,
    loanRecord: {},
    minAmount: 0,
    maxAmount: 0,
    paymentDaySelected: contractEasyLoan.PAYMENT_DAY_OTHER,
    productSubType: '',
    productType: '',
    selectedAccount: '',
    selectedAmount: 0,
    selectedPurpose: '',
    selectedPurposeDrago: '',
    selectedTerm: 0,
    showBiggerImport: false,
    showNewOfferView: false,
    submitSuccessful: false,
    tae: 0,
    tin: 0,
    totalAmount: 0,
    userType: null,
    visibleStep: 1,
    willCancel: false,
    errorDocumentZip: false,
    isFetchingPrintDocuments: false,
    isFetchingNewPurposes: false,
    scrollDown: false,
    checkedRadioButton: false,
    printDocument: false
});

const mapInstallment = (response) => {
    const normal = get(response, 'installmentTae.installmentTae', {});
    const collective = get(response, 'installmentTaeCollective.installmentTae');

    const mapTae = (data) => ({
        tae: get(data, 'tae', 0),
        indIntccp: get(data, 'indIntccp', ''),
        indCapson: get(data, 'indCapson', '')
    });

    const result = {
        isFetchingInstallment: false,
        totalAmount: get(response, 'installmentTae.totalAmount', 0),
        installment: {
            amount: get(normal, 'importePriCuota.importe'),
            currency: get(normal, 'importePriCuota.divisa'),
            decimalsLength: decimalsLength(get(normal, 'importePriCuota.importe'))
        },
        ...mapTae(normal),
    };

    if (collective) {
        result.collectiveInformation = [{
            totalAmount: get(response, 'installmentTaeCollective.totalAmount', 0),
            collectiveName: get(response, 'installmentTaeCollective.collectiveName', 0),
            installment: get(collective, 'importePriCuota.importe'),
            ...mapTae(collective),
        }];
    }

    return result;
};

const mapMinTerm = (action) => {
    const minTerm = action.payload.minTerm > payrollLoanLayoutKOxDTI.MAX_TERM ?
        payrollLoanLayoutKOxDTI.MAX_TERM : action.payload.minTerm;

    return {
        isFetchingMinTerm: false,
        minTerm
    };
};

const mapOfferDTI = (state, response) => {
    const { minTerm } = response;
    const maxAmount = state.get('maxAmount');
    const selectedAmount = state.get('selectedAmount');
    const maxTerm = payrollLoanLayoutKOxDTI.MAX_TERM;
    const lower = maxAmount < selectedAmount;

    return {
        isFetchingOfferDTI: false,
        lower,
        maxAmount,
        selectedAmount: lower ? maxAmount : selectedAmount,
        minTerm: minTerm > maxTerm ? maxTerm : minTerm,
        selectedTerm: maxTerm
    };
};

const mapLoanApprovedInfo = (state, response) => {
    return {
        productType: response.productType || '',
        productSubType: response.productSubType || '',
        productStandard: response.referenceStandard || '',
        preApprovalState: response.preApprovalStatus || '',
        maxInstallment: response.maxInstallment || state.get('maxInstallment'),
        tin: response.tin || 0,
        expirationDate: response.expirationDate || '',
        callingApproveService: false,
        isFetching: false
    };
};

const mapOffer = (state, response) => {
    const isCollective = state.get('isCollective');
    let maxAmount;

    if (isCollective) {
        maxAmount = state.get('maxAmount') > payrollLoanLayoutKOxDTI.MAX_AMOUNT_COLLECTIVE ?
            payrollLoanLayoutKOxDTI.MAX_AMOUNT_COLLECTIVE : state.get('maxAmount');
    }
    else {
        maxAmount = state.get('maxAmount') > payrollLoanLayoutKOxDTI.MAX_AMOUNT ?
            payrollLoanLayoutKOxDTI.MAX_AMOUNT : state.get('maxAmount');
    }

    return {
        showBiggerImport: true,
        maxAmount,
        minTerm: state.get('selectedTerm'),
        offer: {
            selectedAmount: response.maxAmount,
            selectedTerm: payrollLoanLayoutKOxDTI.MAX_TERM
        }
    };
};

const mapUpdateBestOffer = (response) => {
    return {
        maxInstallment: response.maxInstallment,
        offer: { isFetching: false },
        productSubType: response.productSubType,
        productType: response.productType,
        tin: response.tin
    };
};

const mapInitilialize = (state, response) => {
    const isCollective = state.get('isCollective');

    const preApprovalState = get(response, 'loanRecordInformation.status', '');
    const collectiveInformation = get(response, 'collectiveInformation', []);
    const maxAmount = isCollective ? get(collectiveInformation, '0.maxAmount') || 0 : get(response, 'loanProductInformation.maxAmount') || 0;

    return {
        arrangementFee: get(response, 'loanRecordInformation.commission') || 0,
        arrangementPercentage: get(response, 'loanRecordInformation.commissionPercentage') || 0,
        initialized: true,
        isFetching: false,
        installment: {
            amount: get(response, 'installment') || 0,
            decimalsLength: decimalsLength(get(response, 'installment'))
        },
        maxAmount,
        maxTerm: get(response, 'loanProductInformation.maxTerm') || 0,
        minAmount: get(response, 'loanProductInformation.minAmount') || 0,
        minTerm: get(response, 'loanProductInformation.minTerm') || 0,
        maxInstallment: get(response, 'loanRecordInformation.maxInstallment') || 0,
        selectedTerm: get(response, 'loanRecordInformation.term') || 0,
        selectedAmount: get(response, 'loanRecordInformation.amount') || 0,
        productSubType: get(response, 'loanRecordInformation.productSubType'),
        subType: get(response, 'loanRecordInformation.productSubType'),
        productType: get(response, 'loanRecordInformation.productType', ''),
        type: get(response, 'loanRecordInformation.productType', ''),
        recordId: get(response, 'loanRecordInformation.recordId', ''),
        productStandard: get(response, 'loanRecordInformation.currentDateReferenceStandard', ''),
        endOfMonthReferenceStandard: get(response, 'loanRecordInformation.endOfMonthReferenceStandard', ''),
        tae: get(response, 'tae') || 0,
        tin: get(response, 'loanRecordInformation.tin') || 0,
        totalAmount: get(response, 'totalAmount') || 0,
        selectedPurpose: get(response, 'loanRecordInformation.purpose', ''),
        selectedPurposeDrago: get(response, 'loanRecordInformation.purposeDrago', ''),
        preApprovalState,
        job: get(response, 'financialInformation.jobType', payrollLoanJobs.PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE),
        companyMonths: get(response, 'financialInformation.jobSeniorityInMonths', ''),
        companyYears: get(response, 'financialInformation.jobSeniorityInYears', ''),
        regime: get(response, 'financialInformation.housingType', ''),
        civilStatus: get(response, 'financialInformation.maritalStatus', ''),
        userType: get(response, 'loanRecordInformation.userType'),
        income: {
            amount: get(response, 'financialInformation.netIncome') || 0,
            extra: (get(response, 'financialInformation.additionalPayments') || 0).toString()
        },
        outcome: {
            rent: get(response, 'financialInformation.rent') || 0,
            mortgage: get(response, 'financialInformation.mortgageFee') || 0,
            others: get(response, 'financialInformation.otherLoanInstallments') || 0,
        },
        creditCards: get(response, 'financialInformation.numberOfCreditCards', ''),
        showNewOfferView: preApprovalState === NUEVA_OFERTA,
        isCollective,
        collectiveInformation
    }
};

const processPropositionResponse = (state, response) => {
    return state.mergeDeep({
        proposition: {
            ...response,
            isFetching: false,
            success: true
        }
    });
};

function setAgree(state) {
    const agree = !state.get('agree');
    const timesTampCheckBox = new Date().getTime();

    return state.setIn(['steps', SECOND_STEP, 'valid'], agree).merge({
        agree,
        agreeError: false,
        timesTampCheckBox,
    });
}

function validateStepTwo(state, stepIndex) {
    const agree = state.get('agree');

    return state.setIn(['steps', stepIndex, 'valid'], agree)
        .merge({
            agree,
            agreeError: !agree
        });
}

const validateStep = (state, action) => {
    const currentStep = action.payload.currentStep;

    const stepIndex = currentStep - 1;
    let partialState = state.setIn(['steps', stepIndex, 'valid'], true); // set step as valid.

    if (stepIndex === SECOND_STEP) {
        partialState = validateStepTwo(partialState, stepIndex);
    } else {
        const selectedAccount = state.get('selectedAccount');
        partialState = partialState.merge({
            visibleStep: !!selectedAccount ? currentStep + 1 : currentStep,
            emptySelectedAccount: !selectedAccount
        });
    }

    return state.merge(partialState);
};

const getNewPurposes = (state, action) => {
    const newPurposesList = get(action, 'payload.response.data.categories', []).map(newPurpose => {
        return {
            id: newPurpose.key,
            text: formatText(newPurpose.keyPoeditor),
            icon: newPurpose.fontIcon,
            operationCode: newPurpose.key,
            subCategory: newPurpose.subCategory,
        }
    });

    return state.merge({
        isFetchingNewPurposes: false,
        newPurposesList,
    });
}

const contractPayrollLoanReducer = handleActions(
    {
        [simpleActions.contractPayrollLoanInstallment]: state =>
            state.set('isFetchingInstallment', true),
        [simpleActions.contractPayrollLoanInstallmentSuccess]: (state, action) =>
            state.mergeDeep(mapInstallment(action.payload.response)),
        [simpleActions.contractPayrollLoanInstallmentError]: state =>
            state.set('isFetchingInstallment', false),
        [simpleActions.contractPayrollLoanOffer]: state =>
            state.set('isFetchingOffer', true),
        [simpleActions.contractPayrollLoanOfferSuccess]: (state, action) =>
            state.mergeDeep(mapOffer(state, action.payload.response)),
        [simpleActions.contractPayrollLoanOfferError]: state =>
            state.merge({ isFetchingOffer: false }),
        [simpleActions.contractPayrollLoanOfferDti]: state =>
            state.set('isFetchingOfferDTI', true),
        [simpleActions.contractPayrollLoanOfferDtiSuccess]: (state, action) =>
            state.merge(mapOfferDTI(state, action.payload.response)),
        [simpleActions.contractPayrollLoanOfferDtiError]: state =>
            state.set('isFetchingOfferDTI', false),
        [simpleActions.contractPayrollLoanMinTerm]: state =>
            state.set('isFetchingMinTerm', true),
        [simpleActions.contractPayrollLoanMinTermSuccess]: (state, action) =>
            state.merge(mapMinTerm(action)),
        [simpleActions.contractPayrollLoanMinTermError]: state =>
            state.set('isFetchingMinTerm', false),
        [simpleActions.contractPayrollLoanSetTermNewOffer]: (state, action) =>
            state.merge({
                newOffer: {
                    seletedAmountOrTerm: true
                },
                selectedTerm: action.payload.term
            }),
        [simpleActions.contractPayrollLoanSetLoanAmountNewOffer]: (state, action) =>
            state.merge({
                newOffer: {
                    seletedAmountOrTerm: true
                },
                selectedAmount: action.payload.selectedAmount,
                selectedTerm: payrollLoanLayoutKOxDTI.MAX_TERM
            }),
        [simpleActions.contractPayrollLoanSetAccount]: (state, action) =>
            state.set('selectedAccount', action.payload.accountId),
        [simpleActions.contractPayrollLoanSetLoanAmount]: (state, action) =>
            state.merge({
                selectedAmount: action.payload.selectedAmount,
                selectedTerm: payrollLoanLayoutKOxDTI.MAX_TERM,
                offer: {
                    selectedAmount: action.payload.selectedAmount,
                    changed: true
                }
            }),
        [simpleActions.contractPayrollLoanSetTerm]: (state, action) =>
            state.mergeDeep({
                selectedAmount: state.getIn(['offer', 'selectedAmount']),
                selectedTerm: action.payload.term,
                offer: { changed: true }
            }),
        [simpleActions.contractPayrollLoanSetPaymentDay]: (state, action) =>
            state.set('paymentDaySelected', action.payload.paymentDay),
        [simpleActions.contractPayrollLoanInitializeSuccess]: (state, action) =>
            state.merge(mapInitilialize(state, action.payload.response)),
        [simpleActions.contractPayrollLoanHideNewOfferView]: state =>
            state.merge({ showNewOfferView: false }),
        [simpleActions.contractPayrollLoanUpdateOffer]: state =>
            state.merge({ offer: { isFetching: true } }),
        [simpleActions.contractPayrollLoanUpdateOfferSuccess]: (state, action) =>
            state.merge(mapUpdateBestOffer(action.payload.response)),
        [simpleActions.contractPayrollLoanApproveRecordError]: state =>
            state.merge({
                callingApproveService: false,
                isFetching: false,
                error: true
            }),
        [simpleActions.contractPayrollLoanApproveRecord]: state =>
            state.merge({
                callingApproveService: true,
                isFetching: true,
                error: false
            }),
        [simpleActions.contractPayrollLoanApproveRecordApproved]: (state, action) =>
            state.merge(mapLoanApprovedInfo(state, action.payload.response)),
        [simpleActions.contractPayrollLoanResetDocumentAndAgreeCheckbox]: state =>
            state.merge({
                agreeError: false,
                documents: null,
                isFetchingDocuments: true
            }),
        [simpleActions.contractPayrollLoanSetAgree]: state =>
            setAgree(state),
        [simpleActions.contractPayrollLoanProposition]: state =>
            state.mergeDeep({
                proposition: {
                    isFetching: true,
                    success: false
                }
            }),
        [simpleActions.contractPayrollLoanPropositionSuccess]: (state, action) =>
            processPropositionResponse(state, action.payload),
        [simpleActions.contractPayrollLoanPropositionError]: state =>
            state.mergeDeep({
                proposition: {
                    isFetching: false,
                    success: false
                }
            }),
        [simpleActions.contractPayrollLoanHiringDocuments]: state =>
            state.merge({
                isFetchingDocuments: true,
                errorDocuments: false
            }),
        [simpleActions.contractPayrollLoanHiringDocumentsSuccess]: (state, action) =>
            state.merge({
                isFetchingDocuments: false,
                documents: action.payload.documents,
                errorDocuments: false
            }),
        [simpleActions.contractPayrollLoanHiringDocumentsError]: state =>
            state.merge({
                isFetchingDocuments: false,
                errorDocuments: true
            }),
        [simpleActions.contractPayrollLoanHiringIsFetchingDocuments]: state =>
            state.merge({
                isFetchingDocuments: false
            }),
        [simpleActions.contractPayrollLoanSetVisibleStep]: (state, action) =>
            state.merge({ visibleStep: action.payload.visibleStep }),
        [simpleActions.contractPayrollLoanResetState]: state =>
            state.merge(setInitialState()),
        [simpleActions.contractPayrollLoanValidateStep]: (state, action) =>
            validateStep(state, action),
        [simpleActions.contractPayrollLoanInitialize]: state =>
            state.merge({
                isFetching: true,
                errorContractInitialize: false,
                error: false
            }),
        [simpleActions.contractPayrollLoanFormalize]: state =>
            state.merge({
                isFetchingFormalize: true,
                error: false,
                submitSuccessful: false
            }),
        [simpleActions.contractPayrollLoanFormalizeSuccess]: state =>
            state.merge({
                isFetching: false,
                isFetchingFormalize: false,
                submitSuccessful: true
            }),
        [simpleActions.contractPayrollLoanFormalizeError]: state =>
            state.merge({
                isFetching: false,
                isFetchingFormalize: false,
                submitSuccessful: false,
                error: true
            }),
        [simpleActions.contractPayrollLoanInitializeError]: state =>
            state.merge({
                errorContractInitialize: true
            }),
        [simpleActions.contractPayrollLoanUpdateOfferError]: state =>
            state.merge({
                error: true
            }),
        [simpleActions.contractPayrollLoanSaveInProgressError]: state =>
            state.mergeDeep({
                isFetching: false,
                newOffer: {
                    seletedAmountOrTerm: false
                },
                error: true
            }),
        [simpleActions.contractPayrollLoanDownloadZipDocument]: state =>
            state.merge({
                isFetchingZip: true,
                errorDocumentZip: false
            }),
        [simpleActions.contractPayrollLoanDownloadZipDocumentSuccess]: state =>
            state.merge({
                isFetchingZip: false,
                errorDocumentZip: false
            }),
        [simpleActions.contractPayrollLoanDownloadZipDocumentError]: state =>
            state.merge({
                isFetchingZip: false,
                errorDocumentZip: true
            }),
        [simpleActions.contractPayrollLoanSetInactiveAccount]: state =>
            state.merge({
                isInactiveAccount: true
            }),
        [simpleActions.contractPayrollLoanSetCollective]: (state, action) =>
            state.merge({ isCollective: true, collectiveName: action.payload.title }),
        [simpleActions.contractPayrollLoanDownloadPrintDocument]: state =>
            state.set('isFetchingPrintDocuments', true),
        [simpleActions.contractPayrollLoanGetPurposes]: (state) =>
            state.set('isFetchingNewPurposes', true),
        [simpleActions.contractPayrollLoanGetPurposesError]: (state) =>
            state.set('isFetchingNewPurposes', false),
        [simpleActions.contractPayrollLoanGetPurposesSuccess]: (state, action) =>
            getNewPurposes(state, action),
        [combineActions(
            simpleActions.contractPayrollLoanDownloadPrintDocumentError,
            simpleActions.contractPayrollLoanDownloadPrintDocumentSuccess
        )]: state =>
                state.set('isFetchingPrintDocuments', false),
        [simpleActions.contractPayrollLoanInitSuccess]: (state, action) =>
            state.merge({
                payrollInitOperationProcessId: action.payload.payrollInitOperationProcessId,
                changeStatusINE: false
            }),
        [simpleActions.contractPayrollLoanInitError]: (state) =>
            state.merge({
                error: true,
            }),
        [simpleActions.getPayrollLoanPolicyDocumentSuccess]: (state, action) => state.merge({
            filePayrollLoanPolicyDocument: `data:application/pdf;base64,${action.payload.base64}`,
            filePayrollLoanPolicyDocumentId: action.payload.documentId,
            isFetchingDocuments: false,
            agree: true
        }),
        [simpleActions.getPayrollLoanPolicyDocumentError]: (state, action) =>
            state.merge({
                error: true,
            }),
        [simpleActions.getPayrollLoanExpedientIneSuccess]: (state, action) =>
            state.merge({
                expedientOperationProcessId: action.payload.response.operationProcessId,
            }),
        [simpleActions.getPayrollLoanIneDocumentSuccess]: (state, action) => state.merge({
            filePayrollLoanINEDocument: `data:application/pdf;base64,${action.payload.base64}`,
            filePayrollLoanINEDocumentId: action.payload.documentId,
            isFetchingDocuments: false,
            agree: true
        }),
        [simpleActions.getPayrollLoanIneDocumentError]: (state, action) =>
            state.merge({
                error: true,
            }),
        [simpleActions.contractPayrollLoanReadDocument]: (state, action) =>
            state.merge({
                scrollDown: true,
            }),
        [simpleActions.contractPayrollLoanCheckedRadioButton]: (state, action) => {
            return state.merge({
                checkedRadioButton: action.payload,
            })
        },
        [simpleActions.contractPayrollLoanPrintDocument]: (state, action) => {
            return state.merge({
                printDocument: true,
            })
        },
    },
    setInitialState()
);

module.exports = contractPayrollLoanReducer;
module.exports.setInitialState = setInitialState;
